// @ts-nocheck
import React, { useState } from 'react';

import PackageTypesList from './components/PackageTypeList';
import ActionBar from '../../layout/ActionBar';
import EditPackageType from './slideout/EditPackageType';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function PackageTypes() {
  const [pageTitle, setPageTitle] = usePageTitle(['Package types', 'Settings']);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();
  const [addPackageTypeSlideoutOpen, setAddPackageTypeSlideoutOpen] =
    useState(false);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setAddPackageTypeSlideoutOpen(true)}
          text={t('Add package type')}
          testId="add-package-type-button"
        />
      </ActionBar>
      <PackageTypesList reload={reload} />

      <SlidingPane
        isOpen={addPackageTypeSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddPackageTypeSlideoutOpen(false)}
      >
        <EditPackageType
          done={(d) => {
            setReload(new Date());
            setAddPackageTypeSlideoutOpen(false);
          }}
          cancel={() => setAddPackageTypeSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default PackageTypes;
